/* eslint-disable */

//react
import React from "react";

//redux
import { connect } from 'react-redux'

//developer
import PropTypes from "prop-types";

//routing
import { Switch, Route, Redirect } from "react-router-dom";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//routing
import dashboardRoutes from "routes/dashboard.jsx";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import Alerts from "views/Alerts/Alerts.jsx";
import BlogPostList from "views/BlogPostList/BlogPostList.jsx";
import ClassList from "views/ClassList/ClassList.jsx";
import CourseList from "views/CourseList/CourseList.jsx";
import LessonList from "views/LessonList/LessonList.jsx";
import Maps from "views/Maps/Maps.jsx";
import OrdersList from "views/OrdersList/OrdersList.jsx";
import OrganizationPage from "views/Organization/OrganizationPage";
import ProductsList from "views/ProductsList/ProductsList.jsx";
import PurchaseList from "views/PurchaseList/PurchaseList.jsx";
import SchoolList from "views/SchoolList/SchoolList.jsx";
import StudentList from "views/StudentList/StudentList.jsx";
import SupportMaterial from "views/SupportMaterial/SupportMaterial.jsx";
import TaskList from "views/TaskList/TaskList.jsx";
import TeacherList from "views/TeacherList/TeacherList.jsx";
import Stripe from "views/Stripe/Stripe.jsx";
import UserProfile from "views/UserProfile/UserProfile";
import VideosList from "views/VideosList/VideosList.jsx";

//styles
import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

//images
import image from "assets/img/danna1.png";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  getRoute() {
    return this.props.location.pathname !== "/maps";
  }

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  isAdminOnly(navItem) {
    return !navItem.isAdminOnly;
  }

  componentWillMount() {
    if(this.props.user.authenticated) {
      
      // hide ATEQ admin from customers
      var filteredRoutes;
      if(this.props.user.id == "co0aj6VhqQiB3ArmAQ3A")
        filteredRoutes = dashboardRoutes;
      else 
        filteredRoutes = dashboardRoutes.filter(this.isAdminOnly);

    } else {
      console.log('user NOT authenticated, wtf');
      window.location = '/login';
    };
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    window.addEventListener("resize", this.resizeFunction);
    
    //document.body.appendChild(intercom);
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }

  render() {
    const { classes, ...rest } = this.props;

    var params = {};
    if(this.props.location.search.length>0) {
      var values = this.props.location.search.substr(1).split("&");
      for(var i = 0; i < values.length; i++) {
        var keyValue = values[i].split("=");
        params[keyValue[0]] = keyValue[1];
      }
    }
    
    const switchRoutes = (
      <Switch>
        {dashboardRoutes.map((prop, key) => {

          if (this.props.location.pathname == "/") {
            return <Route key="{key}" path={prop.path} render={(props) => (
              <DashboardPage authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/alerts") {
            return <Route key={key} path={prop.path} render={(props) => (
              <Alerts authUser={this.state.authUser} />
            )} />
          }
          else if (this.props.location.pathname == "/blogposts") {
            return <Route key={key} path={prop.path} render={(props) => (
              <BlogPostList authUser={this.state.authUser} />
            )} />
          }
          else if (this.props.location.pathname == "/user") {
            return <Route key={key} path={prop.path} render={(props) => (
              <UserProfile authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/classes") {
            return <Route key={key} path={prop.path} render={(props) => (
              <ClassList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/courses") {
            return <Route key={key} path={prop.path} render={(props) => (
              <CourseList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/lessons") {
            return <Route key={key} path={prop.path} render={(props) => (
              <LessonList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/videos") {
            return <Route key={key} path={prop.path} render={(props) => (
              <VideosList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/products") {
            return <Route key={key} path={prop.path} render={(props) => (
              <ProductsList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/purchases") {
            return <Route key={key} path={prop.path} render={(props) => (
              <PurchaseList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/maps") {
            return <Route key={key} path={prop.path} render={(props) => (
              <Maps authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/orders") {
            return <Route key={key} path={prop.path} render={(props) => (
              <OrdersList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/org") {
            return <Route key={key} path={prop.path} render={(props) => (
              <OrganizationPage authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/schools") {
            return <Route key={key} path={prop.path} render={(props) => (
              <SchoolList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/students") {
            return <Route key={key} path={prop.path} render={(props) => (
              <StudentList authUser={this.state.authUser} userType="student" />
            )} />
          }

          else if (this.props.location.pathname == "/staff") {
            return <Route key={key} path={prop.path} render={(props) => (
              <TeacherList authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/stripe") {
            return <Route key={key} path={prop.path} render={(props) => (
              <Stripe authUser={this.state.authUser} params={params} />
            )} />
          }

          else if (this.props.location.pathname == "/supportMaterial") {
            return <Route key={key} path={prop.path} render={(props) => (
              <SupportMaterial authUser={this.state.authUser} />
            )} />
          }

          else if (this.props.location.pathname == "/tasks") {
            return <Route key={key} path={prop.path} render={(props) => (
              <TaskList authUser={this.state.authUser} params={params} />
            )} />
          }

          /*
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          return <Route path={prop.path} render={(props) => (
            
          )} /> // component={prop.component} key={key} authUser={this.state.authUser} />;
          */
          
        })}
      </Switch>
    );

    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes}
          logoText={"All Things EQ"}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          {...rest}
        />
        <div className={classes.mainPanel} ref="mainPanel">
          <Header
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />

          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}

          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}

          {this.getRoute() ? <Footer /> : null}

        </div>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return state;
}

App = connect(mapStateToProps)(App);
export default withStyles(dashboardStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx